exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-sm[data-v-697e2099] {\n    font-size: 0.9em;\n}\n.table-sm td[data-v-697e2099] {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n    vertical-align: middle;\n}\n.font-xs[data-v-697e2099] {\n    font-size: 0.6em;\n}\n.input-group[data-v-697e2099] {\n    align-self: flex-start;\n}\n.edit-button[data-v-697e2099] {\n    position: relative;\n    top: -4px;\n    opacity: 0;\n}\n.edit-button[data-v-697e2099]:hover {\n    opacity: 1;\n}     \n", ""]);

// exports
